import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Download from 'yet-another-react-lightbox/plugins/download';
import 'yet-another-react-lightbox/styles.css';
import { IconButton } from '@mui/material';
import { CloudDownload, ZoomIn, ZoomOut, Close, NavigateNext, NavigateBefore } from '@mui/icons-material';
import { useWindowSize } from '../../hooks';
const defaultPlugins = { zoom: true, download: true };
const ImageViewer = ({ open, onClose, slides, plugins = {
    zoom: true,
    download: true,
}, customSlideRenderProps = {}, }) => {
    const ref = useRef(null);
    const pluginsToApply = Object.assign(Object.assign({}, defaultPlugins), plugins);
    const enabledPlugins = [...(pluginsToApply.zoom ? [Zoom] : []), ...(pluginsToApply.download ? [Download] : [])];
    // custom rendering area
    const { customSlideRender, nextPageClick, previousPageClick, nextPageClickAvailable, previousPageClickAvailable } = customSlideRenderProps;
    const { height } = useWindowSize();
    return (_jsx(Lightbox, { open: open, close: onClose, slides: slides, plugins: enabledPlugins, zoom: { maxZoomPixelRatio: 10 }, carousel: { finite: true }, controller: { closeOnBackdropClick: true, ref }, download: {
            download: ({ slide, saveAs }) => {
                const fileName = new URL(slide.download.url).pathname.split('/').pop();
                saveAs(slide.download.url, fileName);
            },
        }, render: Object.assign({ iconDownload: () => _jsx(CloudDownload, {}), iconZoomIn: () => _jsx(ZoomIn, {}), iconZoomOut: () => _jsx(ZoomOut, {}), iconClose: () => _jsx(Close, {}), buttonPrev: () => {
                if (slides.length === 1 && !customSlideRenderProps.customSlideRender) {
                    return null;
                }
                if (!customSlideRenderProps.customSlideRender) {
                    return (_jsx(IconButton, { onClick: () => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.prev(); }, sx: { position: 'absolute', left: 0, py: `${height / 2 - 100}px`, pr: '50px' }, size: 'large', children: _jsx(NavigateBefore, { sx: { color: 'white' } }) }));
                }
                // custom rendering area
                return (_jsx(IconButton, { onClick: (e) => {
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        if (previousPageClick) {
                            previousPageClick();
                        }
                    }, sx: {
                        position: 'absolute',
                        left: 0,
                        py: `${height / 2 - 100}px`,
                        pr: '50px',
                        pointerEvents: 'auto !important',
                    }, size: 'large', disabled: !previousPageClickAvailable, children: _jsx(NavigateBefore, { sx: { color: 'white' } }) }));
            }, buttonNext: () => {
                if (slides.length === 1 && !customSlideRenderProps.customSlideRender) {
                    return null;
                }
                if (!customSlideRenderProps.customSlideRender) {
                    return (_jsx(IconButton, { onClick: () => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.next(); }, sx: {
                            position: 'absolute',
                            right: 0,
                            py: `${height / 2 - 100}px`,
                            pl: '50px',
                        }, size: 'large', children: _jsx(NavigateNext, { sx: { color: 'white' } }) }));
                }
                // custom rendering area
                return (_jsx(IconButton, { onClick: (e) => {
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        if (nextPageClick) {
                            nextPageClick();
                        }
                    }, sx: {
                        position: 'absolute',
                        right: 0,
                        py: `${height / 2 - 100}px`,
                        pl: '50px',
                        pointerEvents: 'auto !important',
                    }, size: 'large', disabled: !nextPageClickAvailable, children: _jsx(NavigateNext, { sx: { color: 'white' } }) }));
            } }, (Boolean(customSlideRenderProps.customSlideRender) && Object.assign({}, customSlideRender))) }));
};
export default ImageViewer;
